import SiteNav from "@/pages/home/components/SiteNav";
import Hero from "@/pages/home/components/Hero";
import Synopsis from "@/pages/home/components/Synopsis";
import Versions from "@/pages/home/components/Versions";
import Characters from "@/pages/home/components/Characters";
import Episodes from "@/pages/home/components/Episodes";
import Gallery from "@/pages/home/components/Gallery";
import ViewingGuide from "@/pages/home/components/ViewingGuide";
import Reviews from "@/pages/home/components/Reviews";
import Faq from "@/pages/home/components/Faq";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="w-full bg-background-50 overflow-x-hidden">
      <SiteNav />
      <main className="w-full">
        <Hero />
        <Synopsis />
        <Versions />
        <Characters />
        <Episodes />
        <Gallery />
        <ViewingGuide />
        <Reviews />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}